<template>
  <div v-loading="!showContent">
    <h3>Formula Detail</h3>
    <SimpleTable :headers="getHeaders()" :items="items" />
  </div>
</template>

<script>
import SimpleTable from '@/components/dx/SimpleTable'

export default {
  components: {
    SimpleTable
  },
  props: {
    formula: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      items: [],
      showContent: false
    }
  },
  mounted() {
    this.fetchDataById()
  },
  methods: {
    getHeaders() {
      return [
        {
          type: 'Variable 1',
          value: 'Source_1_Name'
        },
        {
          type: 'Function 1',
          value: 'ProcessForm_1'
        },
        {
          type: 'Operators',
          value: 'OperationFormula'
        },
        {
          type: 'Variable 2',
          value: 'Source_2_Name'
        },
        {
          type: 'Function 2',
          value: 'ProcessForm_2'
        },
        {
          type: 'Variable',
          value: 'VarName'
        }
      ]
    },
    async fetchDataById() {
      try {
        this.showContent = false
        const res = await this.$axios.get(
          this.$appInfo.api.formula.decryptFormulaToFormulaCreateModel +
            `?idFormula=${this.formula.Id}`
        )

        this.items = res.data

        this.showContent = true
      } catch (error) {
        this.showContent = true
        console.log(error)
      }
    }
  }
}
</script>
